export default function ButtonLayoutStyle({ isRtl, alignStart }) {
  const halfX = 8;

  const flexDirection = alignStart ? 'row' : 'row-reverse';
  let start;
  let end;
  if (alignStart) {
    start = isRtl ? 'Right' : 'Left';
  } else {
    start = isRtl ? 'Left' : 'Right';
  }
  end = start === 'Right' ? 'Left' : 'Right';

  const container = {
    direction: isRtl ? 'rtl' : 'ltr',
    padding: `${halfX} 0 ${halfX} 0`,
    display: 'flex',
    flexDirection,
    flexWrap: 'wrap',
    width: '100%',
    alignItems: 'center'
  };

  const item = {
    [`padding${end}`]: '16px',
    margin: `${halfX} 0 ${halfX} 0`,

    '&:last-child': { [`padding${end}`]: 0 }
  };

  return { container, item };
}
